import { themes } from '../index.js';
import dark from './dark.css.js';

themes.dark = dark;
//# sourceMappingURL=index.js.map
